<template>
  <div class="help-container">
    <div id="title">
      <div class="container">
        <h3 class="title is-3 helvetica" style="margin-bottom: 0;">
          {{ selectText }}
        </h3>
        <h1 class="title is-1">{{ number }}º</h1>
      </div>
    </div>
    <div id="message" class="postScriptum" :style="{ background: bgColor }">
      <div class="container">
        <h3 class="title is-3" v-html="content"></h3>
      </div>
    </div>
    <div id="close" class="helvetica">
      <div class="container">
        <h4 class="title is-4">
          {{ helpText }}
        </h4>
        <b-button @click="$dlg.closeAll()" expanded size="is-medium is-pink">
          {{ closeText }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['content', 'bgColor', 'number', 'helpText', 'closeText', 'selectText']
}
</script>

<style lang="scss">
.v-dialog-modal .v-dialog-body {
  padding: 0 !important;
}

div.v-dialog div.v-dialog-content {
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px) brightness(1.5);
}

.help-container {
  height: 100%;
  display: grid;
  grid-template-rows: max-content;

  > div {
    justify-self: stretch;
    display: flex;
  }
  .container {
    margin: auto;
    text-align: center;
    padding: 20px;
  }

  #message {
    * {
      color: white;
    }
  }

  #title {
    .title {
      color: #ce3f86;
    }
    img {
      height: 130px;
    }
    h1 {
      font-size: 5em !important;
    }

    h4 {
      margin-bottom: 0;
    }
  }

  #close {
    .title {
      color: #ce3f86;
    }

    .help-container {
      height: 100%;
      display: grid;
      grid-template-rows: 33% 33% 33%;

      > div {
        justify-self: stretch;
        display: flex;
      }
      .container {
        margin: auto;
        text-align: center;
        padding: 20px;
      }

      #message {
        background: red; /*COLOR */

        * {
          color: white;
        }
      }

      #title {
        .title {
          color: var(--rosa-dark-eco);
        }
        img {
          height: 130px;
        }
        h1 {
          font-size: 5em !important;
        }

        h4 {
          margin-bottom: 0;
        }
      }

      #close {
        .title {
          color: var(--rosa-dark-eco);
        }
        button {
          background: var(--rosa-dark-eco);
          color: white;
        }
      }
    }
  }
}
</style>
